import React from 'react';

import { Box, Grid, type BoxProps, type GridProps, useBreakpointValue } from '@vimeo/bokeh';

import { usePlaylistStyles } from '../../hooks/use-playlist';

export interface PlaylistGridProps extends GridProps {
  /** The column counts in each row, it has to be integer. Base default to 5; highly recommended to handle in each breakpoint */
  numColumns?: number | Record<string, number>;
  /** The maximum row counts allowed, if set, extra items will be cut; if not set,  */
  maxRows?: number;
}

const DEFAULT_BASE_COLUMNS = 5;
/**
 * PlaylistGrid default to be 5 * 2 grid layout,
 * extra grid items will be cut off if exceed the limit.
 * If grid item has a min width, a min width constrains should be applied to grid as well.
 */
export const PlaylistGrid = ({
  numColumns = DEFAULT_BASE_COLUMNS,
  maxRows,
  children,
  ...props
}: PlaylistGridProps) => {
  const { outerSpacing, gap } = usePlaylistStyles();

  const columnsBreakpointSet =
    typeof numColumns === 'object'
      ? { base: DEFAULT_BASE_COLUMNS, ...numColumns }
      : { base: numColumns };

  const columns =
    useBreakpointValue(columnsBreakpointSet, { fallback: 'base', ssr: false }) ??
    DEFAULT_BASE_COLUMNS;

  const renderedChildren =
    typeof maxRows === 'undefined'
      ? children
      : React.Children.toArray(children).slice(0, maxRows * columns);

  return (
    <Grid
      gridTemplateColumns={`repeat(${columns}, minmax(0, 1fr))`}
      gridTemplateRows={`repeat(${maxRows}, minmax(0, 1fr))`}
      gap={gap}
      px={outerSpacing}
      pb={outerSpacing}
      {...props}
    >
      {renderedChildren}
    </Grid>
  );
};

export const VideoList = (props: BoxProps) => {
  return <Box overflowY="auto" {...props} />;
};
